/**
 * Navigation
 *
 * ОПИСАНИЕ
 *
 * Навигация по разделам страницы - вариант реализации якорного меню с использованием js
 * Такая реализация в отличии от якорного меню позволяет
 * 1. добавить плавность
 * 2. прокручивать страницу со смещением, например, если у сайта есть фиксированный header
 * @see: https://coderoad.ru/47519007/%D0%9F%D0%BB%D0%B0%D0%B2%D0%BD%D0%B0%D1%8F-%D0%BF%D1%80%D0%BE%D0%BA%D1%80%D1%83%D1%82%D0%BA%D0%B0-%D1%8F%D0%BA%D0%BE%D1%80%D1%8F-%D0%B8%D0%B4%D0%B5%D0%BD%D1%82%D0%B8%D1%84%D0%B8%D0%BA%D0%B0%D1%82%D0%BE%D1%80%D0%B0-%D0%BD%D0%B5-%D1%80%D0%B0%D0%B1%D0%BE%D1%82%D0%B0%D0%B5%D1%82-%D1%81%D0%BE-%D1%81%D0%BC%D0%B5%D1%89%D0%B5%D0%BD%D0%B8%D0%B5%D0%BC-%D0%B4%D0%BB%D1%8F-%D0%B7%D0%B0%D0%B3%D0%BE%D0%BB%D0%BE%D0%B2%D0%BA%D0%B0
 *
 *
 * ИСПОЛЬЗОВАНИЕ:
 * меню с со ссылками для прокрутки
 * <ul class="content-nav__list swiper-wrapper js-navigation">
     <li class="content-nav__item swiper-slide trs">
      <span class="content-nav__link clr-black trs js-nav-elem" data-nav-elem="about">О мероприятии</span>
     </li>
     <li class="content-nav__item swiper-slide trs">
      <span class="content-nav__link clr-black trs js-nav-elem" data-nav-elem="about">Программа</span>
     </li>
   </ul>
 * элемент к которому нужно прокручивать страницу при нажатии на элемент меню js-nav-elem должен содержать идентификатор указанные в data-атрибуте data-nav-elem
 *
 *
 */

export default class Navigation {

  constructor(menu) {
    this._menu = menu;
    this._elements = this._menu.querySelectorAll('.js-nav-elem');
    this._footer = document.querySelector('.footer');
    this._showHiddenMenu = this._showHiddenMenu.bind(this);
    this.init();
  }

  /**
   * Скрыть меню, если оно попадает на футер
   * @private
   */
  _showHiddenMenu () {
    if(this._footer) {
      if(this._footer.getBoundingClientRect().top < this._menu.getBoundingClientRect().bottom) {
        this._menu.classList.add(`content-nav--hidden`);
      }
      else {
        this._menu.classList.remove(`content-nav--hidden`);
      }
    }
  }

  init() {
    if (this._elements) {
      this._elements.forEach((elem) => {
        elem.addEventListener(`click`, () => {
          let headerHeight = document.querySelector('.header__logo').offsetHeight;
          let offsetPosition;
          if(window.innerWidth >= 1024) {
            let navElement = document.getElementById(elem.getAttribute('data-nav-elem')).querySelector('h2');
            offsetPosition = navElement.getBoundingClientRect().top + document.documentElement.scrollTop - this._menu.getBoundingClientRect().top;
          }
          else {
            let navElement = document.getElementById(elem.getAttribute('data-nav-elem'));
            offsetPosition = navElement.getBoundingClientRect().top + document.documentElement.scrollTop - headerHeight - this._menu.offsetHeight;
          }
          window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
          });
        });
      });
    }

    window.addEventListener(`scroll`, this._showHiddenMenu);
  }

}
